import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "down-arrow_jax_9377cbdeda61f5509ba42073641b4282",
  "use": "down-arrow_jax_9377cbdeda61f5509ba42073641b4282-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"down-arrow_jax_9377cbdeda61f5509ba42073641b4282\">\n<path d=\"M1.31263 3.51037L4.823 7.02074L8.33337 3.51037\" stroke=\"#A9AFB8\" stroke-width=\"1.4\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol